var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "language-selector-container",
      class: {
        "language-selector-container--default-styles": _vm.defaultStyles,
      },
    },
    [
      _c(
        "div",
        { staticClass: "locale-changer" },
        [
          _c(
            "b-dropdown",
            {
              attrs: {
                variant: "link",
                "toggle-class": "text-decoration-none",
                "no-caret": "",
              },
              scopedSlots: _vm._u([
                {
                  key: "button-content",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "vertical-center" },
                        [
                          _c("icon", { attrs: { name: "globe" } }),
                          _vm._v(" "),
                          _c("span", { staticClass: "small ml-1" }, [
                            _vm._v(" " + _vm._s(_vm.currentLocale.text) + " "),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _vm._l(_vm.localeLanguageOptions, function (lang, i) {
                return _c(
                  "b-dropdown-item",
                  {
                    key: "Lang" + i,
                    on: {
                      click: function ($event) {
                        return _vm.handleLanguageSelect(lang.id)
                      },
                    },
                  },
                  [
                    _vm._v("\n        " + _vm._s(lang.text) + "\n        "),
                    _vm.currentLocale.id === lang.id
                      ? _c("icon", { attrs: { name: "check" } })
                      : _vm._e(),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }